import { Notification } from '@/_models/Notification';
import { NotificationService } from "@/services/NotificationService";

export class NotificationUtils{

  async fetchNotifications():Promise<Notification[]>{
    const noti = new NotificationService();
    const fetchedNotification = await noti.getNotification(0, 10);
    if(fetchedNotification){
      return fetchedNotification;
    }else{
      return [];
    }
  }

  async fetchReadNotification(param:string):Promise<void>{
    const noti = new NotificationService();
    await noti.getReadNotification(param);
  }
}